import React, { Component } from 'react';

import MoodChanger from './containers/MoodChanger';

class App extends Component {
  render() {
    return (
      <div>
        <MoodChanger />
      </div>
    );
  }
}

export default App;
